// extracted by mini-css-extract-plugin
export default {"wrapper":"GcU7dh","description":"V8FQd9"};